/* 🤖 this file was generated by svg-to-ts */
export const svgExclamation: {
    name: "exclamation";
    data: string;
} = {
    name: "exclamation",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__exclamation" viewBox="0 0 14 14"><g fill="none" transform="translate(1 1)"><circle cx="6" cy="9" r="1" fill="#9d2a1e" transform="rotate(-180 6 9)"/><rect width="2" height="4" x="5" y="3" fill="#9d2a1e" rx="1" transform="rotate(-180 6 5)"/><circle cx="6" cy="6" r="6" stroke="#9d2a1e"/></g></symbol></svg>`,
};
